










































import { Vue, Component } from 'vue-property-decorator';
import {State} from "vuex-class";

@Component({})
export default class Footer extends Vue {
    @State language: any;
}
